let videoTranscripts = null;

export const InitCommon = (transcripts) => {
    videoTranscripts = transcripts;
};

export const AddLinks = () => {
    const playArea = Array.from(document.querySelectorAll(".vjs-poster"));
    for (let n = 0; n < playArea.length; n++) {
        addVideoClass(playArea[n].getElementsByTagName("img")[0]);
        playArea[n].addEventListener("click", removeVideoClass);
    }
    const playBtn = Array.from(document.querySelectorAll(".vjs-big-play-button"));
    for (let x = 0; x < playBtn.length; x++) {
        addVideoClass(playBtn[x]);
        playBtn[x].addEventListener("click", removeVideoClass);
    }
};

export const ShowFromDialog = () => {
    if (window.location.hash == "#mugimprints") {
        setTimeout(() => {
            const mugImprintBtn = document.getElementById("mugImprintVideo");
            mugImprintBtn.click();
            setTranscriptFocus();
        }, 300);
    } else if (window.location.hash == "#transcript") {
        setTimeout(() => { setTranscriptFocus(); }, 300);
    }
};

function addVideoClass(el) {
    el.classList.add("videoLink"); // for GTM, don't remove
    const productName = document.querySelector(".prodName") ? document.querySelector(".prodName").innerHTML : "";
    if (productName !== "") {
        const svg = document.createElement("svg");
        el.appendChild(svg);
        el.querySelector("svg").setAttribute("aria-label", "Video Gallery for " + productName);
    }
}

function removeVideoClass(e) {
    e.preventDefault();
    const playArea = Array.from(document.querySelectorAll(".vjs-poster"));
    playArea.forEach(area => {
        area.querySelector("img").classList.remove("videoLink");
    });
    const playBtn = Array.from(document.querySelectorAll(".vjs-big-play-button"));
    playBtn.forEach(btn => {
        btn.classList.remove("videoLink");
    });
}

function setTranscriptFocus() {
    if (videoTranscripts) videoTranscripts.collapse();
    const transcriptDiv = document.getElementById("transcriptContainer");
    if (transcriptDiv) transcriptDiv.focus();
}